module.exports = __webpack_public_path__ + "media/images/icons/payment-methods/unionpay-e8332f26ed45671ddc6431af54a8b146.svg";